import { getInfo, setServices, setAddons, getMessage, getChosenFacility, addTime, getCurrentPage } from '../general.js';
import { getFromUrl } from '../functions.js';

export default async function listServices(service) {
    const info = getInfo();
    const facility = getChosenFacility();
    const message = getMessage();

    const form = new FormData();
    form.append('action', 'nobox_list_packages');
    form.append('brand', info.brand);
    form.append('mileage', 3000);
    form.append('service', service);
    form.append('facility', getFromUrl('fac'));
    form.append('pre_service', getFromUrl('serv'));
    form.append('pre_addons', getFromUrl('add'));
    if(getCurrentPage() === 3) {
        form.append('service_type', getFromUrl('type') ?? '');
    }
    if(message && message !== '') {
        form.append('pre_message', message);
    }
    const params = new URLSearchParams(form);

    let resp = "";
    await fetch(horizon.ajaxUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: params
    })
    .then(response => response.json())
    .then(data => {
        if(data.html !== "") {
            resp = data.html;
        }
        if(data.chosen_services.length > 0) {
            data.chosen_services.forEach(item => {
                addTime(item.resourceDemand);
            })
        }
        if(data.services && data.services.length > 0) {
            if(service) {
                setAddons(data.services);
            } else {
                setServices(data.services);
            }
        }
    })
    return resp;
}
